import {actions, useApp} from "../providers/AppProvider.tsx";
import {useMemo} from "react";
import clsx from "clsx";
import CloseButton from "./CloseButton.tsx";

const MobilePracticeInfoWindow = () => {
    const {state, dispatch} = useApp()


    const practice = useMemo(() => {
        return state.selectedPractice
    }, [state])


    return (
        practice ? <div
            className={"z-20  absolute bottom-2 left-6 right-6 rounded-2xl shadow-2xl  bg-white py-4 px-4 overflow-auto  bg-primary small text-white"}>
            <button onClick={() => dispatch(actions.setSelectedPractice(undefined))}
                    className={"absolute p-0.5 top-2 right-2 opacity-80 text-green-700  bg-white  cursor-pointer rounded-full"}>
                <CloseButton size={16}/>
            </button>
            <a className={clsx("flex gap-2  pr-6  cursor-pointer focus:opacity-30", state.selectedPractice ? '' : 'items-center')}
               href={`/hormone-replacement-therapy-provider/${practice.slug}`}>
                <div className="flex-none">
                    <img
                        src={`${import.meta.env.PROD ? `https://${import.meta.env.BASE_URL}` : ''}/assets/provider-badge.svg`}
                        alt="" width={65}
                        className={"mx-auto"}/>
                </div>
                <div className={"flex-grow"}>
                    <h2 className={"text-white leading-snug font-semibold text-sm tracking-wider"}>
                        {practice.name}
                    </h2>
                    <p className={"text-xs opacity-60 mt-1"}>
                        {practice.address}
                    </p>
                </div>
            </a>
        </div> : <></>
    )
}

export default MobilePracticeInfoWindow